export default __webpack_public_path__ + "static/media/045-matches.8ff88a07.svg";